const Data = [
    {
        id : 1,
        name : "Helium Balloon",
        value : 1
    },
    {
        id : 1,
        name : "Bird",
        value : 1
    },
    {
        id : 2,
        name : "Crow",
        value : 1
    },
    {
        id : 3,
        name : "Parrot",
        value : 1
    },
    {
        id : 4,
        name : "Helicopter",
        value : 1
    },
    {
        id : 5,
        name : "UFO",
        value : 1
    },
    {
        id : 6,
        name : "Satellite",
        value : 1
    },
    {
        id : 7,
        name : "Missile",
        value : 1
    },
    {
        id : 8,
        name : "Eagle",
        value : 1
    },
    {
        id : 9,
        name : "Bat",
        value : 1
    },
    {
        id : 10,
        name : "Airplane",
        value : 1
    },
    {
        id : 11,
        name : "Drone",
        value : 1
    },
    {
        id : 12,
        name : "Bees",
        value : 1
    },
    {
        id : 13,
        name : "Glider",
        value : 1
    },
    {
        id : 14,
        name : "Rocket",
        value : 1
    },
    {
        id : 15,
        name : "Kite",
        value : 1
    },
    {
        id : 16,
        name : "Wasp",
        value : 1
    },
    {
        id : 17,
        name : "Flying Squirrel",
        value : 1
    },
    {
        id : 18,
        name : "Hot Air Balloon",
        value : 1
    },
    {
        id : 19,
        name : "Dragonfly",
        value : 1
    },
    {
        id : 20,
        name : "Dragon",
        value : 1
    },
    {
        id : 21,
        name : "Woodpecker",
        value : 1
    },
    {
        id : 22,
        name : "Sparrow",
        value : 1
    },
    {
        id : 23,
        name : "Owl",
        value : 1
    },
    {
        id : 24,
        name : "Nightingale",
        value : 1
    },
    {
        id : 25,
        name : "Dove",
        value : 1
    },
    {
        id : 26,
        name : "Robbin",
        value : 1
    },
    {
        id : 27,
        name : "Goldfinch",
        value : 1
    },
    {
        id : 28,
        name : "Finch",
        value : 1
    },
    {
        id : 29,
        name : "Herons",
        value : 1
    },
    {
        id : 30,
        name : "Hawk",
        value : 1
    },
    {
        id : 31,
        name : "Vulture",
        value : 1
    },
    {
        id : 32,
        name : "Peacock",
        value : 1
    },
    {
        id : 33,
        name : "Swift",
        value : 1
    },
    {
        id : 34,
        name : "Falcon",
        value : 1
    },
    {
        id : 35,
        name : "Flamingo",
        value : 1
    },
    {
        id : 36,
        name : "Hornbill",
        value : 1
    },
    {
        id : 37,
        name : "Bulbul",
        value : 1
    },
    {
        id : 38,
        name : "Kingfisher",
        value : 1
    },
    {
        id : 39,
        name : "Houseflies",
        value : 1
    },
    {
        id : 40,
        name : "Mosquitoes",
        value : 1
    },
    {
        id : 41,
        name : "Humming Bird",
        value : 1
    },
    {
        id : 42,
        name : "Butterflies",
        value : 1
    },
    {
        id : 43,
        name : "Beetles",
        value : 1
    },
    {
        id : 44,
        name : "Shazam!",
        value : 1
    },
    {
        id : 45,
        name : "Iron Man",
        value : 1
    },
    {
        id : 46,
        name : "Captain Marvel",
        value : 1
    },
    {
        id : 47,
        name : "Superman",
        value : 1
    },
    {
        id : 48,
        name : "Dassult Rafael",
        value : 1
    },
    {
        id : 49,
        name : "Eurofighter Typhoon",
        value : 1
    },
    {
        id : 50,
        name : "MIG-21",
        value : 1
    },
    {
        id : 51,
        name : "F-22 Raptor",
        value : 1
    },
    {
        id : 52,
        name : "Apache",
        value : 1
    },
    {
        id : 53,
        name : "Eurocopter Tiger",
        value : 1
    },
    {
        id : 54,
        name : "Chinook",
        value : 1
    },
    {
        id : 55,
        name : "Atlas-V",
        value : 1
    },
    {
        id : 56,
        name : "Big Falcon Rocket",
        value : 1
    },
    {
        id : 57,
        name : "Falcon Heavy",
        value : 1
    },
    {
        id : 58,
        name : "Saturn-V",
        value : 1
    },
    {
        id : 59,
        name : "Boeing 747",
        value : 1
    },
    {
        id : 60,
        name : "Airbus A380",
        value : 1
    },
    {
        id : 61,
        name : "Penguin",
        value : 0
    },
    {
        id : 62,
        name : "Ostrich",
        value : 0
    },
    {
        id : 63,
        name : "Emus",
        value : 0
    },
    {
        id : 64,
        name : "Kiwis",
        value : 0
    },
    {
        id : 65,
        name : "Duck",
        value : 0
    },
    {
        id : 66,
        name : "Dodo",
        value : 0
    },
    {
        id : 67,
        name : "Ant",
        value : 0
    },
    {
        id : 68,
        name : "Scorpions",
        value : 0
    },
    {
        id : 69,
        name : "German Shepherd",
        value : 0
    },
    {
        id : 70,
        name : "Bulldog",
        value : 0
    },
    {
        id : 71,
        name : "Dubai",
        value : 0
    },
    {
        id : 72,
        name : "California",
        value : 0
    },
    {
        id : 73,
        name : "London",
        value : 0
    },
    {
        id : 74,
        name : "Berlin",
        value : 0
    },
    {
        id : 75,
        name : "Hong Kong",
        value : 0
    },
    {
        id : 76,
        name : "Tokyo",
        value : 0
    },
    {
        id : 77,
        name : "Paris",
        value : 0
    },
    {
        id : 78,
        name : "Mumbai",
        value : 0
    },
    {
        id : 79,
        name : "Mexico",
        value : 0
    },
    {
        id : 80,
        name : "China",
        value : 0
    },
    {
        id : 81,
        name : "France",
        value : 0
    },
    {
        id : 82,
        name : "Germany",
        value : 0
    },
    {
        id : 83,
        name : "Russia",
        value : 0
    },
    {
        id : 84,
        name : "India",
        value : 0
    },
    {
        id : 85,
        name : "Japan",
        value : 0
    },
    {
        
        id : 86,
        name : "Africa",
        value : 0
    },
    {
        id : 87,
        name : "Asia",
        value : 0
    },
    {
        id : 88,
        name : "Europe",
        value : 0
    },
    {
        id : 89,
        name : "Antartica",
        value : 0
    },
    {
        id : 90,
        name : "Australia",
        value : 0
    },
    {
        id : 91,
        name : "Tiger",
        value : 0
    },
    {
        id : 92,
        name : "Lion",
        value : 0
    },
    {
        id : 93,
        name : "Leopard",
        value : 0
    },
    {
        id : 94,
        name : "Cheetah",
        value : 0
    },
    {
        id : 95,
        name : "Buffalo",
        value : 0
    },
    {
        id : 96,
        name : "Elephant",
        value : 0
    },
    {
        id : 97,
        name : "Bill Gates",
        value : 0
    },
    {
        id : 98,
        name : "Jeff Bezos",
        value : 0
    },
    {
        id : 99,
        name : "Mark Zuckerberg",
        value : 0
    },
    {
        id : 100,
        name : "Tim Apple",
        value : 0
    },
    {
        id : 101,
        name : "Tim Cook",
        value : 0
    },
    {
        id : 102,
        name : "Elon Musk",
        value : 0
    },
    {
        id : 103,
        name : "Dolphin",
        value : 0
    },
    {
        id : 104,
        name : "Whale",
        value : 0
    },
    {
        id : 105,
        name : "Shark",
        value : 0
    },
    {
        id : 106,
        name : "Zebra",
        value : 0
    },
    {
        id : 107,
        name : "Rabbit",
        value : 0
    },
    {
        id : 108,
        name : "Goat",
        value : 0
    },
    {
        id : 109,
        name : "Crab",
        value : 0
    },
    {
        id : 110,
        name : "Deer",
        value : 0
    },
    {
        id : 111,
        name : "Horse",
        value : 0
    },
    {
        id : 112,
        name : "Ox",
        value : 0
    },
    {
        id : 113,
        name : "Panda",
        value : 0
    },
    {
        id : 114,
        name : "Monkey",
        value : 0
    },
    {
        id : 115,
        name : "Cow",
        value : 0
    },
    {
        id : 116,
        name : "Giraffe",
        value : 0
    },
    {
        id : 117,
        name : "Fox",
        value : 0
    },
    {
        id : 118,
        name : "Frog",
        value : 0
    },
    {
        id : 119,
        name : "Bear",
        value : 0
    },
    {
        id : 120,
        name : "Chimpanzee",
        value : 0
    },
    {
        id : 121,
        name : "Kangaroo",
        value : 0
    },
    {
        id : 122,
        name : "Crocodile",
        value : 0
    },
    {
        id : 123,
        name : "Starfish",
        value : 0
    },
    {
        id : 124,
        name : "Apple",
        value : 0
    },
    {
        id : 125,
        name : "Orange",
        value : 0
    },
    {
        id : 126,
        name : "Banana",
        value : 0
    },
    {
        id : 127,
        name : "Grape",
        value : 0
    },
    {
        id : 128,
        name : "Pineapple",
        value : 0
    },
    {
        id : 129,
        name : "Lemon",
        value : 0
    },
    {
        id : 130,
        name : "Avacodo",
        value : 0
    },
    {
        id : 131,
        name : "Mango",
        value : 0
    },
    {
        id : 132,
        name : "Lichee",
        value : 0
    },
    {
        id : 133,
        name : "Strawberry",
        value : 0
    },
    {
        id : 134,
        name : "Leonardo Dicaprio",
        value : 0
    },
    {
        id : 135,
        name : "Robert Drowney Jr",
        value : 0
    },
    {
        id : 136,
        name : "Dwane Jhonson",
        value : 0
    },
    {
        id : 137,
        name : "Tom Cruise",
        value : 0
    },
    {
        id : 138,
        name : "Shahrukh Khan",
        value : 0
    },
    {
        id : 139,
        name : "Joaquin Phoenix",
        value : 0
    },
    {
        id : 140,
        name : "Justin Beiber",
        value : 0
    },
    {
        id : 141,
        name : "Lady Gaga",
        value : 0
    },
    {
        id : 142,
        name : "Taj Mahal",
        value : 0
    },
    {
        id : 143,
        name : "Great Wall of China",
        value : 0
    },
    {
        id : 144,
        name : "Eifiel Tower",
        value : 0
    },
    {
        id : 145,
        name : "Golden Gate Bridge",
        value : 0
    },
    {
        id : 146,
        name : "Pyramid Of Giza",
        value : 0
    },
    {
        id : 147,
        name : "Leaning Tower of Pisa",
        value : 0
    },
    {
        id : 148,
        name : "Amazon Rainforest",
        value : 0
    },
    {
        id : 149,
        name : "Mercedes Benz",
        value : 0
    },
    {
        id : 150,
        name : "Table",
        value : 0
    },
    {
        id : 151,
        name : "Bed",
        value : 0
    },


]
export default Data